var _circle, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMenu(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 54,
    viewBox: "0 0 53 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 26.5,
    cy: 27,
    r: 26,
    stroke: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.1667 26.1667H17.8333C17.3731 26.1667 17 26.5398 17 27.0001C17 27.4603 17.3731 27.8334 17.8333 27.8334H36.1667C36.6269 27.8334 37 27.4603 37 27.0001C37 26.5398 36.6269 26.1667 36.1667 26.1667Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.1667 20.3333H17.8333C17.3731 20.3333 17 20.7063 17 21.1666C17 21.6268 17.3731 21.9999 17.8333 21.9999H36.1667C36.6269 21.9999 37 21.6268 37 21.1666C37 20.7063 36.6269 20.3333 36.1667 20.3333Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36.1667 32H17.8333C17.3731 32 17 32.3731 17 32.8333C17 33.2936 17.3731 33.6667 17.8333 33.6667H36.1667C36.6269 33.6667 37 33.2936 37 32.8333C37 32.3731 36.6269 32 36.1667 32Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu);
export default __webpack_public_path__ + "static/media/menu.044bc6d650b17f690eb194131855baae.svg";
export { ForwardRef as ReactComponent };